import { useQuery } from '@apollo/client';

import user from 'js/lib/user';

import FinAidQueryByUser from 'bundles/my-purchases-graphql/components/tabs/enhancers/FinAidQueryByUser.graphql';
import type {
  FinAidQueryByUserQuery,
  FinAidQueryByUserQueryVariables,
} from 'bundles/my-purchases-graphql/components/tabs/enhancers/__generated__/FinAidQueryByUser';

type PropsFromUseHasFinancialAidApplications = {
  hasFinancialAidApplications: boolean;
  loading: boolean;
};

export const useHasFinancialAidApplications = ({
  skip,
}: { skip?: boolean } = {}): PropsFromUseHasFinancialAidApplications => {
  const { data, loading } = useQuery<FinAidQueryByUserQuery, FinAidQueryByUserQueryVariables>(FinAidQueryByUser, {
    variables: {
      userId: skip ? '' : user.get().id.toString(),
      limit: 1,
    },
    skip,
    errorPolicy: 'all',
    context: { clientName: 'gatewayGql' },
  });

  return {
    hasFinancialAidApplications: Boolean(data?.FinancialAidApplication?.queryByUser?.elements?.length),
    loading,
  };
};
